import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'shared-badge',
  templateUrl: './badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SharedBadgeComponent {
  @Input() class = 'badge badge-pill badge-info';
  @Input() label: string;
  @Input() tooltip: string;
}
